import React, { useEffect } from "react";
import { upcomingEventsService } from "../../../../api/services/upcomingEventsService";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  upcomingEventsLoader,
  upcomingEventsReducer,
} from "../../../../infra/aggregates/upcomingEventsSlice";

interface eventsProps {
  setEvents: (events: []) => void;
}

function DTOUpcomingEvents({ setEvents }: eventsProps) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);

  async function getEventsList(empId: number) {
    dispatch(upcomingEventsLoader(true));
    const response = await upcomingEventsService.upcomingEvents(empId);
    if (response.response == "success") {
      dispatch(upcomingEventsReducer(response?.data?.upcomming_events));
      setEvents(response?.data?.upcomming_events);
      dispatch(upcomingEventsLoader(false));
    } else {
      dispatch(upcomingEventsLoader(false));
      return;
    }
  }
  useEffect(() => {
    if (selector.authSlice.emp_id) getEventsList(selector.authSlice.emp_id);
  }, []);

  return <></>;
}
export default DTOUpcomingEvents;
